import styled, { css } from "styled-components";
import { buttonPalette } from "../../../assets/colors";

export const Button = styled.button`
  ${({ disabled, variant = 'primary' }) => {
    const variantPalette = buttonPalette[variant];
    const baseBg = disabled ? buttonPalette.disabled.base : variantPalette.base;
    const baseColor = disabled ? buttonPalette.disabled.text : variantPalette.text;
    const baseBorder = variant === "ghost" ? buttonPalette.ghost.border : baseBg;
  
    return css`
      background-color: ${baseBg};
      color: ${baseColor};
      padding: 13px;
      border: 1px solid ${baseBorder};
      border-radius: 3px;
      font-size: medium;
      text-transform: uppercase;
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
      transition: background-color 0.2s ease, color 0.2s ease;

      &:hover {
        background-color: ${disabled ? buttonPalette.disabled.base : variantPalette.hover};
        color: ${disabled ? buttonPalette.disabled.text : variantPalette.text};
      }
    `;
  }}
`;
